//(()=>{
  let activeCharmArr = [];


  let chainImage = document.getElementById('charm-preview').innerHTML;
  //const url = new URL(location.href);
  const urlParams = new URLSearchParams(window.location.search);
  const paramCharms = urlParams.get('charms');

  if(paramCharms){
    //console.log('paramCharms');
    //console.log(paramCharms.split(','));
    if(paramCharms.split(',').length == charmArr.length -1 ){
      activeCharmArr = paramCharms.split(',');
      render();
      console.log('url-------------')
    } else {

      for(i=0; i < charmArr.length-1; i++){
        activeCharmArr.push(`_${i}`)
      }
      render();

    }
  } else {
    const localStorageCharms = localStorage.getItem(`charms-${baseProductHandle}`); 
    //console.log('localStorageCharms');
    //console.log(localStorageCharms);
    if(localStorageCharms){
      let localArr = localStorageCharms.split(',')
      if(localArr.length != charmArr.length - 1){
        localStorage.setItem(`charms-${baseProductHandle}`, '');
      } else {
        // load localStorageCharms
        localArr.forEach((id) => {
          if(id.includes("_")){
            //id is a placeholder
            activeCharmArr.push(id);
          } else {
            // make sure the charm is still available
            let p = charmArr.find((charm) => charm.id == id) 
            if(p){
              activeCharmArr.push(id);
            }
          }
        })

      }
      //activeCharmArr = localStorageCharms.split(',');
    } else {
      for(i=0; i < charmArr.length-1; i++){
        activeCharmArr.push(`_${i}`)
      }
    }
    //console.log('activeCharmArr----------');
    //console.log(activeCharmArr);
    render();
  }

  //activeCharmArr.push(charmArr[0].data.id);

  // Charm window modals   
  const charmInfoBtnArr = Array.from(document.querySelectorAll('.charm__header-info'));
  console.log(charmInfoBtnArr);
  const charmModalArr = Array.from(document.querySelectorAll('.charm-modal'));
  charmInfoBtnArr.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      //console.log(btn.dataset.index)
      //const charmInfo = e.target.parentElement.querySelector('.charm-info');
      charmModalArr[btn.dataset.index].classList.toggle('active');
    })
  })
  const charmModalHeaderCloseBtn = Array.from(document.querySelectorAll('.charm-modal__header-close'));
  charmModalHeaderCloseBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      console.log(btn.dataset.index)
      //const charmInfo = e.target.parentElement.querySelector('.charm-info');
      charmModalArr[btn.dataset.index].classList.remove('active');
    })
  })


  const charmToggleBtn = Array.from(document.querySelectorAll('.charm-toggle-btn'));
  charmToggleBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      console.log(btn.dataset.id)
      //const charmInfo = e.target.parentElement.querySelector('.charm-info');
      //charmModalArr[btn.dataset.index].classList.toggle('active');
      toggleId(btn.dataset.id);
    })
  })

  function toggleId(id){
    console.log(activeCharmArr.indexOf(id))
    if(activeCharmArr.indexOf(id) > -1){
      //console.log('remove');
      //console.log(activeCharmArr.indexOf(id))
      //activeCharmArr.splice(activeCharmArr.indexOf(id), 1);

      activeCharmArr[activeCharmArr.indexOf(id)] = `_${randomNum()}`;
    } else {

      //console.log('add');

      let complete = false;
      [...document.getElementsByClassName('charm-preview__item')].forEach((el, i) => {
        if(complete == false && el.dataset.id.includes('_')){
          activeCharmArr[i] = id;
          //console.log(id)
          //console.log(el.dataset.id)
          complete = true;
          //swapElements(el.dataset.id, id)
        }
      })

      //activeCharmArr.push(id);

    }
    render();
  }

  function randomNum() {
    const randomNumber = Math.floor(Math.random() * 100000000); // generates a random number between 0 and 99,999,999
    return randomNumber.toString().padStart(8, '0');
  }

  // add to cart event listenters
  document.querySelector('.charm-add-to-cart').addEventListener('click', (e) => { 
    e.preventDefault();
    addToCart();
   });

  let personalizeBtn = document.querySelector('.personalize');
  personalizeBtn.addEventListener('click', (e) => { 
    personalizeBtn.classList.toggle('active');

    document.getElementById('charm-preview').classList.toggle('active');
    document.getElementsByClassName('design-message')[0].classList.toggle('active');
    
   });


  //console.log(charmArr[0].data.id)

  function render(){
    updateCount();
    updateTotal();
    updateCharmIndicator();
    //console.log('activeCharmArr');
    //console.log(activeCharmArr);
    updatePreview();
    buildLink();
    updateLocalStorage();
  }

  function updateCount(){
    const charmCount = document.querySelector('.charm-window__header-count-value');

    let activeCount = 0;
    activeCharmArr.forEach(id => {
      if(!id.includes('_')){
        activeCount++;
      }
    })

    //charmCount.innerHTML = activeCharmArr.length;
    charmCount.innerHTML = activeCount;
  }

  function updateTotal(){
    let total = baseProductPrice;
    //console.log('activeCharmArr---------------------------')
    //console.log(activeCharmArr)
    if(activeCharmArr.length > 0){
      activeCharmArr.forEach((id) => {
        let p = charmArr.find((charm) => charm.data.id == id)
        if(p){
          //console.log('p');
          //console.log(p);
          total += p.data.price;
        }
      })
    }
    document.querySelector('.charm-window__header-total-value').innerHTML = '$' + total * .01 ;
    document.querySelector('.charm-total').innerHTML = '$' + total * .01 ;
  }


  function updateCharmIndicator(){
    const charmDivArr = Array.from(document.querySelectorAll('.charm'));
    charmDivArr.forEach((el) => {
      //console.log(' remove active')
      el.classList.remove('active');
    })
    activeCharmArr.forEach((activeId) => {
      charmDivArr.forEach((el) => {
        if(el.dataset.id == activeId){

          //console.log(' add active')
          el.classList.add('active');
        }
      })

    })
  }


	function addToCart(){

    let items = [
        {
          'id': baseProductVariantId,
          'quantity': 1
        }
      ]
    activeCharmArr.forEach((id) => {
      if(!id.includes('_')) {
        let p = charmArr.find((charm) => charm.data.id == id)

        //console.log('id');
        //console.log(id);
        //console.log('p');
        //console.log(p);
        let variantId = p.data.variants[0].id;
        items.push(
          {
            'id': variantId,
            'quantity': 1
          }
        );
      }
    })

		let formData;
			formData = {
			'items': items 
			};

      //console.log('formData');
      //console.log(formData);

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
		.then(response => {
			return response.json();
		})
		.then(response =>{

      document.dispatchEvent(new CustomEvent('product:added', { detail: { quantity: items.length } }));
      localStorage.removeItem('charms')
			//const cartDrawer = document.querySelector('cart-drawer');
			//cartDrawer.renderContents(response);
		})
		.catch((error) => {
			console.error('Error:', error);
		});
	}

  const swapElements = (id1, id2) => {
    let index1 = activeCharmArr.indexOf(id1)
    let index2 = activeCharmArr.indexOf(id2)
    let temp = activeCharmArr[index1];
    activeCharmArr[index1] = activeCharmArr[index2];
    activeCharmArr[index2] = temp;
  };

  function updatePreview(){
    let html = '';
    activeCharmArr.forEach((id, i) => {
      //let p = charmArr.find((charm) => charm.data.id == id)
      let p = charmArr.find((charm) => charm.id == id)
      //console.log('p');
      //console.log(p);

      let pointsArr = [];
      let rotateArr = [];

      if(includesCharm){
        let circlePointsArr = circlePointsArray(charmArr.length - 1 + Math.round(charmArr.length / 1.5));
        if(chainType == "bracelet"){
        circlePointsArr = circlePointsArray(charmArr.length);
        }
        //pointsArr = circlePointsArr;
        //pointsArr.push(circlePointsArr[0])

        for(let i = 1; i < charmArr.length; i++){
          if(isOdd(i)){
          pointsArr.push(circlePointsArr[Math.round(i/2)]);
          } else {
            pointsArr.push(circlePointsArr[(circlePointsArr.length - 1) - Math.round((i - 2)  / 2 )]);
          }
        }

        for(let i = 1; i < charmArr.length; i++){
          let deg = 360 / circlePointsArr.length;
          //console.log('deg');
          //console.log(deg);
          //console.log('circlePointsArr.length');
          //console.log(circlePointsArr.length);
          if(isOdd(i)){
            let rotation = deg * (Math.round(i/2)) * -1;
            rotateArr.push(rotation);
          } else {
            let rotation = deg * (Math.round((i - 1 )/2));
            rotateArr.push(rotation);
          }
        }

      } else {

        let circlePointsArr = circlePointsArray(charmArr.length - 1);
        //pointsArr = circlePointsArr;
        pointsArr.push(circlePointsArr[0])

        for(let i = 1; i < circlePointsArr.length; i++){

          if(isOdd(i)){
            pointsArr.push(circlePointsArr[Math.round(i/2)]);
          } else {
            pointsArr.push(circlePointsArr[(circlePointsArr.length - 1) - Math.round((i - 2)  / 2 )]);
          }
        }

        for(let i = 0; i < charmArr.length - 1; i++){
          let deg = 360 / circlePointsArr.length;
          if(isOdd(i)){
            let rotation = deg * (Math.round(i/2)) * -1;
            rotateArr.push(rotation);
          } else {
            let rotation = deg * (Math.round(i/2));
            rotateArr.push(rotation);
          }

        }
      }


      //console.log('pointsArr');
      //console.log(pointsArr);
      //console.log('rotateArr');
      //console.log(rotateArr);
      if(p){
        //console.log('charmArr.length')
        //console.log(charmArr.length)
        //let img = p.data.images[0];
        let img = p.image;
        let rotate = (360 / (charmArr.length - 1)) * i * -1;
        
        //html += `<div class="drag-container c${i +1}" data-id="${id}"><div class="charm-preview__item" data-id="${id}" style="background-image: url('${img}')" draggable="true"><button class="remove-charm-btn"></button></div></div>`;
        html += `<div class="charm-preview__item c${i +1}" data-id="${id}" style="background-image: url('${img}'); transform: translate(-50%, -50%) rotate(${rotateArr[i]}deg); top: ${pointsArr[i].y}%;  left: ${pointsArr[i].x}%;" draggable="true"><button class="remove-charm-btn"></button></div>`;

        //document.querySelector('#charm-preview').style.backgroundImage = 'url(' + img + ')';
      } else if (id.includes('_')){
        html += `<div class="charm-preview__item empty-item c${i +1}" data-id="${id}" style="background: none; transform: translate(-50%, -50%) rotate(${rotateArr[i]}deg); top: ${pointsArr[i].y}%;  left: ${pointsArr[i].x}%;" draggable="false"></div>`;
      }
    })
    html += chainImage;
    document.querySelector('#charm-preview').innerHTML = html;


    const draggables = document.querySelectorAll('.charm-preview__item');
    const containers = document.querySelectorAll('.drag-container');


    let dragOverId = null;

    draggables.forEach(draggable => {
      draggable.addEventListener('dragstart', () => {
        draggable.classList.add('dragging')
        document.getElementById('charm-preview').classList.add('item-dragging');
      })


      draggable.addEventListener('dragend', () => {
        //console.log(dragOverId);
        //console.log(activeCharmArr);
        //swap(dragOverId, draggable.dataset.id);
        swapElements(dragOverId, draggable.dataset.id);
        //console.log(activeCharmArr);
        render();
        //console.log(document.getElementById('charm-preview-container').dataset.dragOverId);
        draggable.classList.remove('dragging')
        document.getElementById('charm-preview').classList.remove('item-dragging');
      })
    })

    //containers.forEach(container => {
    draggables.forEach(draggable => {
      //container.addEventListener('dragover', e => {
      draggable.addEventListener('dragover', e => {
        e.preventDefault()
        //console.log(e.target.dataset.id);
        dragOverId = e.target.dataset.id;
        //e.target.classList.add('drag-over')
        //document.getElementById('charm-preview-container').setAttribute('data-drag-over-id', dragOverId);
        //const afterElement = getDragAfterElement(container, e.clientY)
        //const draggable = document.querySelector('.dragging')
        //if (afterElement == null) {
          //container.appendChild(draggable)
        //} else {
          //container.insertBefore(draggable, afterElement)
        //}
      })
    })

    draggables.forEach(draggable => {
      draggable.addEventListener('dragover', e => {
        e.preventDefault();
        e.target.classList.add('drag-over')
      })
    })

    draggables.forEach(draggable => {
      draggable.addEventListener('dragleave', e => {
        e.preventDefault()
        e.target.classList.remove('drag-over')
      })
    })


    // mobile drag

    const draggablesMobile = document.querySelectorAll('.charm-preview__item:not(.empty-item)');

    draggablesMobile.forEach(draggable => {
      draggable.addEventListener('touchmove', (e) => {
        e.preventDefault();
        let touchLocation = e.targetTouches[0];
        //console.log(touchLocation)
        //console.log(e)
        draggable.classList.add('dragging');
        draggable.style.transform = 'translate(-50%, -50%) rotate(0deg)';
        let tempWidth = draggable.offsetWidth;
        let tempHeight = draggable.offsetHeight;
        draggable.style.width = tempWidth + 'px';
        draggable.style.height = tempHeight + 'px';
        draggable.style.position = 'fixed';
        draggable.style.zIndex = 999999;
        draggable.style.left = touchLocation.clientX + 'px';
        draggable.style.top = touchLocation.clientY + 'px';

        //draggable.classList.add('dragging')

        document.getElementById('charm-preview').classList.add('item-dragging');
      })


      draggable.addEventListener('touchend', (e) => {
        //console.log('touchend')
        //console.log(e)

        const staticDraggables = document.querySelectorAll('.charm-preview__item:not(.dragging)');

        //draggable.classList.remove('dragging');
        //console.log('staticDraggables');
        //console.log(staticDraggables);


        //staticDraggables.forEach(draggable => {
        let dragging = document.querySelector('.dragging');

        draggable.classList.remove('dragging')
        document.getElementById('charm-preview').classList.remove('item-dragging');

        let draggingX = dragging.getBoundingClientRect().x + (dragging.getBoundingClientRect().width / 2);
        let draggingY = dragging.getBoundingClientRect().y + (dragging.getBoundingClientRect().height / 2); 

        let count = 0

        for(let i = 0; i < staticDraggables.length; i++){
          staticDraggables[i].style.transform = 'translate(-50%, -50%) rotate(0deg)';
          let rect = staticDraggables[i].getBoundingClientRect();
          //console.log(rect.y)
          //console.log(rect.y)

          //let t = newDiv = document.createElement("div");
          //t.className = 't'
          //t.style.width = e.target.width + 'px';
          //t.style.height = rect.height + 'px';
          //t.style.top = rect.top + 'px';
          //t.style.left = rect.left + 'px';

          //document.body.appendChild(t);

          //let div = newDiv = document.createElement("div");
          //div.className = 'test'
          //div.style.width = rect.width + 'px';
          //div.style.height = rect.height + 'px';
          //div.style.top = rect.top + 'px';
          //div.style.left = rect.left + 'px';

          //document.body.appendChild(div);

          //console.log('------------------------------------');
          //console.log('------------------------------------');
          //console.log('------------------------------------');
          //console.log('draggingX',draggingX);
          //console.log('draggingY',draggingY);

          //console.log('rect.top',rect.top);
          //console.log('rect.bottom',rect.bottom);
          //console.log('rect.left',rect.left);
          //console.log('rect.right',rect.right);

          //if(e.target.offsetTop > rect.top && e.target.offsetTop < rect.bottom && e.target.offsetLeft > rect.left && e.target.offsetLeft < rect.right){
          if(draggingY > rect.top && draggingY < rect.bottom && draggingX > rect.left && draggingX < rect.right){
            //console.log('touchend inside')
            //console.log(staticDraggables[i].dataset.id)

          
          //console.log(rect.y)
            swapElements(staticDraggables[i].dataset.id, dragging.dataset.id);
            render();
            break;

          } else {
            count++;
          }
          if(count == staticDraggables.length){
            //console.log('touchend outside')
            render();
          }
        }

        //console.log(dragOverId);
        //console.log(activeCharmArr);
        //swap(dragOverId, draggable.dataset.id);
        //swapElements(dragOverId, draggable.dataset.id);
        //console.log(activeCharmArr);
        //render();
        //console.log(document.getElementById('charm-preview-container').dataset.dragOverId);
        //draggable.classList.remove('dragging')
      })
    })


    const removeChamrBtn = [...document.querySelectorAll('.remove-charm-btn')];
    removeChamrBtn.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        //console.log(e.target.parentElement.dataset.id);
        toggleId(e.target.parentElement.dataset.id)
        //const charmInfo = e.target.parentElement.querySelector('.charm-info');
        //charmModalArr[btn.dataset.index].classList.remove('active');
      })
    })


  }


  function buildLink(){
    let charms = '';
    activeCharmArr.forEach((id) => {
      charms += id + ',';
    })
    charms = charms.slice(0, -1);

    const url = new URL(location.href);
    url.searchParams.set('charms', charms);
    //console.log(url.href)
    return url.href;
    //window.history.replaceState(statedata, '', url.href);
  }

  document.getElementsByClassName('share')[0].addEventListener('click', (e) => {
    let shareLink = buildLink();
    document.getElementsByClassName('share-modal')[0].classList.toggle('active');
    document.getElementsByTagName('body')[0].classList.toggle('overflowHidden');
    document.getElementsByClassName('share-link')[0].value = shareLink;
    document.getElementsByClassName('share-modal__copy')[0].innerHTML = 'COPY';
  })

  document.getElementsByClassName('share-modal__close')[0].addEventListener('click', (e) => {
    document.getElementsByClassName('share-modal')[0].classList.toggle('active');
    document.getElementsByTagName('body')[0].classList.toggle('overflowHidden');
  })

  document.getElementsByClassName('share-modal__copy')[0].addEventListener('click', (e) => {
    copyTextToClipboard(buildLink())
  })
  

  function updateLocalStorage(){   
    //localStorage.setItem("charms", activeCharmArr.join(','));
    localStorage.setItem(`charms-${baseProductHandle}`, activeCharmArr.join(','));
  }

  function circlePointsArray(numPoints){
    // Circle parameters
    const radius = 50;  // Radius of the circle
    const centerX = 50; // X-coordinate of the center
    const centerY = 50; // Y-coordinate of the center

    // Array to store the points
    const points = [];

    // Starting angle at the bottom of the circle (270° or 3 * Math.PI / 2 radians)
    const startAngle = (5 * Math.PI) / 2;
    //const startAngle = 180;

    // Loop to calculate the points
    for (let i = 0; i < numPoints; i++) {
      // Calculate angle for each point (counterclockwise)
      const angle = startAngle + (i * 2 * Math.PI) / numPoints;

      // Calculate the x and y coordinates of each point
      const x = (centerX - radius * Math.cos(angle));
      const y = (centerY + radius * Math.sin(angle));

      // Store the point
      points.push({ x: x, y: y });
    }
    return points;
  }

  function fallbackCopyTextToClipboard(text) {
  var textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand("copy");
    var msg = successful ? "successful" : "unsuccessful";
    console.log("Fallback: Copying text command was " + msg);
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err);
  }

  document.body.removeChild(textArea);
}

function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function() {
      console.log("Async: Copying to clipboard was successful!");
      document.getElementsByClassName('share-modal__copy')[0].innerHTML = 'COPIED!';
      setTimeout(() => {
        document.getElementsByClassName('share-modal')[0].classList.toggle('active');
        document.getElementsByTagName('body')[0].classList.toggle('overflowHidden');
      }, 1000);
    },
    function(err) {
      console.error("Async: Could not copy text: ", err);
    }
    
  );
}

function isOdd(n) {
  return Math.abs(n % 2) == 1;
}


//})();




